module.exports = __webpack_public_path__ + "img/1 (22).8f24ff8e.png";